export default {
  default: 'Une erreur est survenue',
  app: {
    network_error: 'Pas de connexion au serveur. Vérifiez votre connexion.',
  },
  server: {
    default: 'Une erreur serveur est survenue',
    400: 'Une erreur serveur est survenue',
    404: '404 Le serveur n\'a pas trouvé l\'element indiquée',
    409: 'Cet enregistrement a été modifié par un autre utilisateur depuis le démarrage de modification. Veuillez recommencer l\'operation',
    500: 'Une erreur serveur est survenue',
  },
};
